import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useDocumentTitle from '../../hooks/DocumentTitle/documentTitle';
import { Modal } from '../Modal/Modal.component';
import { TabItem } from '../Tabs/VerticalTabs/VerticalTabs.types';
import { VerticalTabs } from '../Tabs/VerticalTabs/VerticalTabs.component';
import { ExamineeInfo } from './ExamineeInfo.component';
import { ExamineeDetailsSessionInfo } from './ExamineeDetailsSessionInfo.component';
import { getExamineeDetails } from '../../services/images/images.service';
import { AxiosResponse } from 'axios';
import { IExamineeInfoDto } from './ExamineeDetails.types';
import { useLayoutContext } from '../../Context/Layout.context';

interface IExamineeDetails {
  onClose: () => void;
  examineeId?: string;
}

export const ExamineeDetails: React.FC<IExamineeDetails> = ({ onClose, examineeId }) => {
  const { t } = useTranslation();
  useDocumentTitle('Dane szczegółowe');

  const sampleData: IExamineeInfoDto = {
    id: '',
    examName: '',
    sheetCode: '',
    adjustmentEnabled: null,
    room: '',
    examCommittee: 15,
    schoolCode: '',
    examineeCode: '',
    pesel: '',
    documentNumber: '',
    adjustmentTypes: [''],
    adjustmentPermissions: [''],
    taskSolutionSheetCompleted: true,
    taskSolutionSheetId: '',
  };

  const [data, setData] = useState<IExamineeInfoDto>(sampleData);
  const [taskSheetId, setTaskSheetId] = useState<string>('');
  const { showLoader } = useLayoutContext();
  const items: TabItem[] = [];
  const activeTab = 'Informacje podstawowe';

  useEffect(() => {
    showLoader(true);
    getExamineeDetails(examineeId != undefined ? examineeId : '')
      .then((res: AxiosResponse<IExamineeInfoDto>) => {
        setData(res.data);
        setTaskSheetId(res.data.taskSolutionSheetId)
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => showLoader(false));
  }, []);

  items.push({
    label: activeTab,
    children: <ExamineeInfo data={data} />,
  });

  items.push({
    label: 'Informacje o sesjach oceniania',
    children: <ExamineeDetailsSessionInfo taskSolutionSheetId={taskSheetId} />,
  });

  const getActiveTab = (isCollapsed?: boolean) => {
    const activeTabItem = items.find((item) => item.label === activeTab);
    if (!isCollapsed) {
      if (activeTabItem) {
        return activeTabItem.collapsable
          ? items.map((e) => e.label).indexOf(activeTab) + 1
          : items.map((e) => e.label).indexOf(activeTab);
      }
      return 0;
    } else {
      return activeTabItem && activeTabItem.collapsable ? 0 : -1;
    }
  };

  return (
    <Modal xCloseButton={() => onClose()} open={true} size="xl" title='Dane szczegółowe' heightReducing>
      <VerticalTabs items={items} selectedTab={getActiveTab()} />
    </Modal>
  );
};
